import { treaty } from "@elysiajs/eden";
import { useQuery } from "@tanstack/react-query";
import type { App } from "@/server/server";
import { apiBaseurl } from "./apiBaseurl";

// Create Eden Treaty client, call apis to server.ts with basic type-safe
export const edenClient = treaty<App>(apiBaseurl.get() || origin);

export function useAuthCapabilities() {
  return useQuery({
    queryKey: ["edenClient.api.auth.capabilities.get"],
    queryFn: () => edenClient.api.auth.capabilities.get().then((e) => e.data),
  });
}
